import React, { useContext } from 'react';
import { NavPage } from '../../services/NavService';
import { EditorContext } from '../EditorCommon/EditorContext';
import { EditorNav } from '../EditorNav/EditorNav';
import { TopNav } from '../TopNav/TopNav';
import { ExtraItemsList } from './ExtraItemsList';
import { ExtraProductsList } from './ExtraProductsList';

export function ExtraProductEditor(props: {

}) {

    const ec = useContext(EditorContext);



    return (
        <div className="editor ext-editor extra-product-editor">


            <TopNav header={ec.translator("extra product editor header", "Løssalg")}/>

            <div className="left-toolbox">
                <ExtraProductsList />
            </div>

            <div className="main-editor">
                <ExtraItemsList />
            </div>

            <div className="right-toolbox">

            </div>

            <EditorNav currentPage={NavPage.ExtraProducts} />
        </div>
    );
}
